import { TagsInput, TagsInputProps } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'

type FinishField = {
  finish: Array<string>
}

interface Props<Values extends FinishField> extends Omit<TagsInputProps, 'form'> {
  form: UseFormReturnType<Values>
}

export default function FinishInput<Values extends FinishField>({ form, ...props }: Props<Values>) {
  return (
    <TagsInput
      label="Wykończenie"
      placeholder="Wybierz z listy"
      description="Wybierz maksymalnie 5 cech wykończenia. Możesz wybrać z listy lub wpisać własne."
      maxTags={5}
      acceptValueOnBlur={false}
      data={[
        {
          group: 'Rodzaj taśmy',
          items: ['Taśma ołówek', 'Taśma smok', 'Taśma wave', 'Taśma z kieszeniami', 'Bez taśmy'],
        },
        { group: 'Kolor przelotek', items: ['Przelotki satyna', 'Przelotki antyk'] },
        { group: 'Sposób zawieszenia', items: ['Szelki', 'Tunel'] },
        { group: 'Rodzaj tkaniny', items: ['Woal'] },
        { group: 'Dodatki', items: ['Obciążnik'] },
        { group: 'Rodzaj produktu', items: ['Zasłona', 'Firanka', 'Roleta'] },
        { group: 'Kolor', items: ['Biały', 'Écru', 'Beżowy', 'Bordowy', 'Fioletowy', 'Brązowy', 'Różowy'] },
        { group: 'Podkład', items: ['Oxford', 'Velluto', 'Velvet', 'UNI', 'Żakard'] },
        { group: 'Inne', items: ['Obszyte boki'] },
      ]}
      {...form.getInputProps('finish')}
      {...props}
    />
  )
}
